import { render, staticRenderFns } from "./CarBrands.vue?vue&type=template&id=3e028cc4&scoped=true"
import script from "./CarBrands.vue?vue&type=script&lang=js"
export * from "./CarBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e028cc4",
  null
  
)

export default component.exports